import { VXETable } from 'vxe-table'
// import SignObject from '../../public/utils/signJpg'
import XEUtils from 'xe-utils'
import { ykDateFormat, AmountLtoU } from '../../public/utils/globalFunc'
import http from '../../axios/index'
import { convertSign } from '../../public/utils/getSign'
import { Message } from 'element-ui'

export const handlePrint = async row => {
  const { data: res } = await http.get('/finance/users')
  if (!res.isSuccess) {
    Message.error(res.errorMessage)
    return false
  }

  const SignObject = convertSign(res.data)

  let caiwuSign = ''

  let lingdaoSign = ''

  let lingongSign = ''

  let userNameSign = ''

  if (row.manager_review && row.document_status > 1) {
    lingongSign = `<img src="${SignObject['林源晟']}" />`
  }

  if (row.document_status > 2) {
    caiwuSign = `<img src="${SignObject['连燕燕']}" />`
  }

  if (row.document_status > 5) {
    lingdaoSign = `<img src="${SignObject['姚杨']}" />`
  }

  // 报销人
  if (SignObject[row.users_name]) {
    userNameSign = `<div class="signContainer">报销人:<div class="signItems">
    <img src="${SignObject[row.users_name]}" />
    </div></div>`
  } else {
    userNameSign = `<div>报销人:&nbsp;${row.users_name}</div>`
  }

  const htmlStr = `
    <div class="printContainer">
      <div class="titleContainer">
        <h1 class="mainTitle">零 星 费 用 报 销 单</h1>
      </div>

      <div class="dateContainer">
        <div>报销日期: ${ykDateFormat('yyyy-MM-dd', row.r_date)}</div>
        <div>公司: ${row.company}</div>
      </div>

      <table class="mainTable">
        <tr>
          <td style="width: 150px;">
            <div class="contentContainer">
              <div class="left">粘贴单据</div>
              <div class="mid">${row.document_count}</div>
              <div class="right">张</div>
            </div>
          </td>
          <td>
            <div class="contentContainer">
              <div class="left">共计人民币(大写):&emsp;${AmountLtoU(row['amout'])}</div>
              <div class="mid"></div>
              <div class="right">(&nbsp;￥&nbsp;${XEUtils.commafy(row.amout, { digits: 2 })}&nbsp;)</div>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2" style="padding: 0;">
            <table style="margin: 0;">
              <tr>
                <td style="border: 0; width: 80px;">
                  <div style="width: 100%;height: 100%;text-align: center;">
                    事 由
                  </div>
                </td>
                <td style="border: 0;border-left: 1px solid #000000;">
                  <div style="height: 180px;">${row.subject_matter}</div>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>

      <div class="footerContainer">
        <div class="signContainer">领导审批:
          <div class="signItems">${lingdaoSign}</div>
        </div>
        <div class="signContainer">单位主管:
          <div class="signItems">${lingongSign}</div>
        </div>
        <div class="signContainer">财务审核:
          <div class="signItems">${caiwuSign}</div>
        </div>
          ${userNameSign}
      </div>
    </div>
  `

  const htmlCss = `
      html,
      body {
        width: 100vw;
        height: 100vh;
        margin: 0 !important;
        padding: 0 !important;
      }

      .printContainer {
        height: 50%;
        width: 100%;

        box-sizing: border-box;
        padding: 40px;
      }

      .dateContainer {
        display: flex;
        justify-content: space-between;
      }

      .titleContainer {
        text-align: center;
      }

      .titleContainer h1 {
        font-size: 30px;
        font-weight: 400;
      }

      .footerContainer {
        display: flex;
        justify-content: space-around;
      }

      .footerContainer div {
        width: 20%;
      }

      .mainTable {
        width: 100%;
        /* text-align: center; */
      }

      table {
        /* text-align: center; */
        border-collapse: collapse;
        width: 100%;

        margin: 5px 0 15px 0;
      }

      table td {
        box-sizing: border-box;
        padding: 20px;
        border: 1px solid #000000;

        height: 26px;

        font-size: 14px;
      }

      .contentContainer {
        display: flex;
        justify-content: space-between;
      }

      .contentContainer .left {
        /* margin-right: 10px; */
      }

      .signContainer {
        position: relative;
      }

      .signItems {
        position: absolute;
        left: 70px;
        top: -10px;
      }

      .signItems img {
        width: 80px;
      }
  `

  VXETable.print({
    style: htmlCss,
    // 自定义打印HTML
    content: htmlStr
  })
}
